import React from 'react';
import './GraphCanvas.css';

export const GraphCanvas = ({ plotGraphFn }) => {
    return (
        <div className="canvas-panel">
            {plotGraphFn && plotGraphFn()}
        </div>
    );
};